import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  stores: [],
  store: null,
  isLoading: false,
  success: false,
  error: null,
  message: null,
};

export const storeReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Stores
    .addCase('getAllStoresRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllStoresSuccess', (state, action) => {
      state.isLoading = false;
      state.stores = action.payload;
    })
    .addCase('getAllStoresFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Store Creation
    .addCase('storeCreateRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('storeCreateSuccess', (state, action) => {
      state.isLoading = false;
      state.store = action.payload;
      state.success = true;
    })
    .addCase('storeCreateFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Edit Store
    .addCase('editStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.store = action.payload;
      state.success = true;
    })
    .addCase('editStoreFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Store
    .addCase('deleteStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = "Store deleted successfully!";
      state.stores = state.stores.filter(store => store._id !== action.payload);
    })
    .addCase('deleteStoreFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});